module.exports = __webpack_public_path__ + "img/leave-review.5f5da8b9.jpg";